var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99778 19.3274V14.3274H13.9978V19.3274C13.9978 19.8774 14.4478 20.3274 14.9978 20.3274H17.9978C18.5478 20.3274 18.9978 19.8774 18.9978 19.3274V12.3274H20.6978C21.1578 12.3274 21.3778 11.7574 21.0278 11.4574L12.6678 3.92736C12.2878 3.58736 11.7078 3.58736 11.3278 3.92736L2.96778 11.4574C2.62778 11.7574 2.83778 12.3274 3.29778 12.3274H4.99778V19.3274C4.99778 19.8774 5.44778 20.3274 5.99778 20.3274H8.99778C9.54778 20.3274 9.99778 19.8774 9.99778 19.3274Z",
    fill: "#9498AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeUnselected);
export default __webpack_public_path__ + "static/media/home_unselected.7542a8927add61e56a90e76f36bdf344.svg";
export { ForwardRef as ReactComponent };